import { REQUEST_USER_SEVICES, RECEIVE_USER_SEVICES, IUserServiceState, UserServiceTypes } from "./types";

const initialState: IUserServiceState = {
    loadingServices: false,
};

export function userServiceReducer(state = initialState, action: UserServiceTypes): IUserServiceState {
    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case REQUEST_USER_SEVICES:
            return {
                ...state,
                loadingServices: true,
            };
        case RECEIVE_USER_SEVICES:
            return {
                ...state,
                loadingServices: false,
                serviceCategories: action.serviceCategories,
            };
        default:
            return state;
    }
}
